import { render, staticRenderFns } from "./Payouts.vue?vue&type=template&id=c39a5008&scoped=true&"
import script from "./Payouts.vue?vue&type=script&lang=js&"
export * from "./Payouts.vue?vue&type=script&lang=js&"
import style0 from "./Payouts.vue?vue&type=style&index=0&id=c39a5008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39a5008",
  null
  
)

export default component.exports